import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from '../../src/Context/AuthContext';
import Modal from '../../Components/Shared/Modal';
import AuthHeader from '../../Components/Account/AuthHeader';

const RegisterAgentPage = ({ portalSettings }) => {
    //State Variables
    const { login, isAuthenticated } = useAuth();
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        portalRegistrationCode: "",
        ssnLast4: "",
        username: "",
        email: "",
        confirmEmail: "",
        password: "",
        confirmPassword: "",
    });
    const [modalData, setModalData] = useState({
        show: false,
        message: "",
        onAction: null,
    });
    const navigate = useNavigate();

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    //Set Site Title
    document.title = `${companyName} - Register Agent`;

    // If loading auth or no portal settings yet, just render nothing
    if (!portalSettings) return null;

    const psm = portalSettings || {};

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/home');
        }
        if (psm.hasAgentPortal == false) {
            if (psm.hasPolicyPortal == true) {
                navigate('/register');
            }
            else {
                navigate('/login');
            }
        }
    }, [isAuthenticated, navigate]);

    const handleChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Basic validation
        if (formData.email !== formData.confirmEmail) {
            setModalData({
                show: true,
                message: "Emails do not match",
                onAction: null,
            });
            return;
        }
        if (formData.password !== formData.confirmPassword) {
            setModalData({
                show: true,
                message: "Passwords do not match",
                onAction: null,
            });
            return;
        }

        const payload = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            portalRegistrationCode: formData.portalRegistrationCode,
            lastFour: formData.ssnLast4,
            userName: formData.username,
            email: formData.email,
            password: formData.password,
        };

        try {
            const res = await fetch(`${apiURL}/account/register-agent`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (res.ok) {
                setModalData({
                    show: true,
                    message: data.message || "Registration successful!",
                    onAction: () => navigate("/login"),
                });
            } else {
                setModalData({
                    show: true,
                    message: data.message || "Registration failed",
                    onAction: null,
                });
            }
        } catch (err) {
            console.error("Registration error:", err);
            setModalData({
                show: true,
                message: "Something went wrong. Please try again.",
                onAction: null,
            });
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <AuthHeader portalSettings={portalSettings} />
                <h2 className="baseHeader">Register Agent</h2>
                <form className="baseForm" onSubmit={handleSubmit}>
                    <label className="baseLabel">First Name</label>
                    <input
                        type="test"
                        name="firstName"
                        className="baseInput"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                    />
                    <label className="baseLabel">Last Name</label>
                    <input
                        type="text"
                        name="lastName"
                        className="baseInput"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                    />
                    <label className="baseLabel">Username</label>
                    <input
                        type="text"
                        name="username"
                        className="baseInput"
                        value={formData.username}
                        onChange={handleChange}
                        required
                    />
                    <label className="baseLabel">Email</label>
                    <input
                        type="email"
                        name="email"
                        className="baseInput"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                    <label className="baseLabel">Confirm Email</label>
                    <input
                        type="email"
                        name="confirmEmail"
                        className="baseInput"
                        value={formData.confirmEmail}
                        onChange={handleChange}
                        required
                    />

                    <label className="baseLabel">Last 4 SSN</label>
                    <input
                        type="text"
                        name="ssnLast4"
                        className="baseInput"
                        value={formData.ssnLast4}
                        onChange={handleChange}
                        required
                        maxLength="4"
                        pattern="\d{4}"
                    />

                    <label className="baseLabel">Registration Code</label>
                    <input
                        type="text"
                        name="portalRegistrationCode"
                        className="baseInput"
                        value={formData.portalRegistrationCode}
                        onChange={handleChange}
                        required
                        maxLength="7"
                    />

                    <label className="baseLabel">Password</label>
                    <input
                        type="password"
                        name="password"
                        className="baseInput"
                        value={formData.password}
                        onChange={handleChange}
                        required
                    />

                    <label className="baseLabel">Confirm Password</label>
                    <input
                        type="password"
                        name="confirmPassword"
                        className="baseInput"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        required
                    />

                    <button className="baseButton" type="submit">Register</button>
                </form>

                <div className="auth-links">
                    <Link to="/login">Back to Login</Link>

                    {psm.hasPolicyPortal && (
                        <Link to="/register">Register User</Link>
                    )}

                    {psm.hasPolicyPortal && (
                        <Link to="/registerEntity">Register Entity</Link>
                    )}
                </div>
            </div>

            <Modal
                show={modalData.show}
                message={modalData.message}
                onClose={() => setModalData({ ...modalData, show: false })}
                onAction={modalData.onAction}
                actionLabel="Go to Login"
            />
        </div>
    );
};

export default RegisterAgentPage;
